module.exports = __webpack_public_path__ + "static/media/ico-arrowdown.b290de8d.svg";